export default __webpack_public_path__ + "static/media/ordersEmpty.56cb3ebb.png";